
/** 按钮权限自定义编码对象 */
export const permissionCode = {
    reportBtn: '/performance/collusion-warning/handleList/exportBtn',
    handleBtn: '/performance/collusion-warning/handleList/handleBtn'
};

export default {
    configuration: false,
    reportCode: 'COLLUSION_WARN_HANDLE_TAB_EXPORT',
    searchList: {
        searchTxt: [
            {
                name: '发车单号',
                value: 'dispatchNo',
                type: 'input',
                unfold: true,
                span: 4
            },
            {
                name: '服务平台',
                value: 'siteName',
                unfold: true,
                multiple: true,
                border: true,
                hideTooltip: true,
                maxNum: 10,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'escoCompanyNameCn', 'value': '服务平台名称'
                },
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称', displayName: true }
                ],
                prefix: '/api-mdm',
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                type: 'advanceMulti',
                span: 4
            },
            {
                name: '客户',
                value: 'customerName',
                prop: 'customerName',
                type: 'advanceMulti',
                readOnly: false,
                multiple: true,
                // maxNum: 5,
                border: true,
                hideTooltip: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'ebcuNameCn', 'value': '客户名称'
                },
                advanceConfig: [
                    { prop: 'ebcuNameCn', value: '客户名称' },
                    { prop: 'pmCode', value: '客户编码' }
                ],
                tableConfig: [
                    { prop: 'pmCode', value: '客户编码' },
                    { prop: 'ebcuNameCn', value: '客户名称', displayName: true }
                ],
                cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
                prefix: '/api-mdm',
                advanceUrl: '/ebCustomer/searchByEbCustomer',
                unfold: true,
                span: 4
            },
            {
                name: '预警类型',
                value: 'warningTypeList',
                type: 'select',
                // optionNum: 'CHANGE_MONITOR_WARNING_TYPE',
                options: [],
                unfold: true,
                span: 4,
                multiple: true
            },
            {
                name: '预警等级',
                value: 'urgencyType',
                type: 'select',
                optionNum: 'URGENCY_WARNING_TYPE',
                options: [],
                unfold: true,
                span: 3,
                multiple: false
            },

            {
                name: '预警状态',
                value: 'monitorStatus',
                type: 'select',
                optionNum: 'CHANGE_MONITOR_WARNING_STATUS',
                options: [],
                unfold: true,
                span: 3,
                multiple: true,
                data: ['1']
            },

            {
                name: '预警时间',
                value: 'firstMonitorTime',
                type: 'time',
                unfold: true,
                span: 6,
                timeNum: 6,
                startPlaceholder: '预警开始时间',
                endPlaceholder: '预警结束时间'
            }
        ],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        height: 400,
        leftOperation: true,
        leftWidth: 60,
        selectBtn: false,
        columns: [
            {
                label: '剩余处理时间(分钟)',
                prop: 'remainingProcessingTime',
                sort: true,
                width: 170
            },
            {
                label: '预警等级',
                prop: '__urgencyTypeName__',
                type: 'custom',
                align: 'center',
                sort: true,
                width: 110
            },
            {
                label: '是否及时处理',
                prop: 'isTimelyDispose',
                type: 'select',
                sort: true,
                width: 130,
                optionNum: 'TIMELY_DISPOSE_TYPE',
                options: []
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                width: 160
            },
            {
                label: '司机名称',
                prop: 'driver',
                sort: true,
                width: 105
            },
            {
                label: '司机联系方式',
                prop: 'driverContactWay',
                sort: true,
                width: 130
            },
            {
                label: '调度人员',
                prop: 'dispatchCreateUserName',
                sort: true,
                width: 110
            },
            {
                label: '装卸方式',
                prop: '__loadingMethod__',
                sort: true,
                width: 110
            },
            {
                label: '发车时间',
                prop: 'dispatchTime',
                sort: true,
                width: 160
            },
            {
                label: '承运商',
                prop: 'carrierName',
                sort: true,
                width: 160
            },
            {
                label: '采购渠道',
                prop: 'procurementChannel',
                type: 'select',
                optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: '车牌号',
                sort: true,
                prop: 'vehicleCard',
                width: 100
            },
            {
                label: '专业公司',
                prop: 'professionalCompany',
                type: 'select',
                options: [],
                optionNum: 'JD_PROFESSIONAL_COMPANY',
                sort: true,
                width: 120
            },
            {
                label: '分公司',
                prop: 'companyName',
                sort: true,
                width: 160
            },
            {
                label: '经营中心',
                prop: 'centerName',
                width: 170,
                sort: true
            },
            {
                label: '服务平台',
                prop: 'siteName',
                sort: true,
                width: 160
            },
            {
                label: '发运类型',
                prop: 'shippingType',
                type: 'select',
                optionNum: 'TMS_SHIPPING_TYPE',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: '线路',
                prop: 'lineName',
                sort: true,
                width: 200
            },
            {
                label: '客户',
                prop: 'customerName',
                width: 240,
                sort: true
            },
            {
                label: '预警类型',
                prop: '__warningTypeName__',
                sort: true,
                width: 130
            },
            {
                label: '预警时间',
                prop: 'warningTime',
                sort: true,
                width: 160
            },
            {
                label: '预警状态',
                prop: 'warningStatus',
                type: 'select',
                optionNum: 'CHANGE_MONITOR_WARNING_STATUS',
                options: [],
                sort: true,
                width: 110
            },
            {
                label: '预警原因',
                prop: 'warningReason',
                sort: true,
                width: 240
            },
            {
                label: '预警处理时间',
                prop: 'warningProcessTime',
                sort: true,
                width: 160
            },
            {
                label: '预警发生地点',
                prop: 'locationName',
                sort: true,
                width: 240
            },
            {
                label: '预警处理人',
                prop: 'warningProcessor',
                sort: true,
                width: 130
            },
            {
                label: '备注',
                prop: 'remark',
                sort: true,
                width: 240
            },
            {
                label: '智能拨号时间',
                prop: 'virtualDialTime',
                sort: true,
                width: 160
            },
            {
                label: '智能拨号状态',
                prop: 'virtualDialStatus',
                type: 'select',
                optionNum: 'DISPATCH_VIRTUAL_DIAL_STATUS',
                options: [],
                sort: true,
                width: 130
            },
            {
                label: '智能拨号内容',
                prop: 'virtualDialContent',
                sort: true,
                width: 240
            },
            {
                label: '行业',
                prop: '__industryCategory__',
                sort: true,
                width: 130
            },
            {
                label: '考核预警时间',
                prop: 'assessWarningTime',
                sort: true,
                width: 150
            }
        ],
        action: [
            {
                type: 'text',
                label: '处理',
                size: 'mini',
                event: 'handle',
                ifHas: permissionCode.handleBtn,
                // 待处理才显示
                show(row) {
                    return +row.warningStatus === 1;
                }
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 20,
        pageSizes: [10, 20, 30, 50, 100]
    },
    searchTotalTitle: [
        {
            name: '调度人员',
            value: 'dispatchCreateUserName',
            type: 'input',
            span: 3,
            unfold: true,
            data: ''
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '分公司名称' },
                { prop: 'escoCompanyNo', value: '分公司编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '分公司名称' },
                { prop: 'escoCompanyNo', value: '分公司编码' }
            ],
            advanceUrl: '/searchBrand',
            cbParams: [
                'escoCompanyNameCn#companyName',
                'escoCompanyNo#companyCode'
            ]
        },
        {
            name: '经营中心',
            value: 'centerName',
            disabled: false,
            type: 'advance',
            advanceConfig: [
                { prop: 'escoCompanyNameCn', value: '经营中心名称' },
                { prop: 'escoCompanyNo', value: '经营中心编码' }
            ],
            tableConfig: [
                { prop: 'escoCompanyNameCn', value: '经营中心名称' },
                { prop: 'escoCompanyNo', value: '经营中心编码' }
            ],
            method: 'post',
            prefix: '/api-opms/',
            advanceUrl: 'opms/management/queryManagementForMdm',
            cbParams: ['escoCompanyNo#centerCode', 'escoCompanyNameCn#centerName']
        },
        {
            name: '预警处理人',
            value: 'monitorProcessor',
            type: 'input'
        },
        {
            name: '发车时间',
            value: 'dispatchTime',
            type: 'time',
            startPlaceholder: '发车开始时间',
            endPlaceholder: '发车结束时间'
        },

        {
            name: '司机',
            type: 'advanceMulti',
            value: 'driver',
            multiple: true,
            border: true,
            hideTooltip: true,
            dialogWidth: '800px',
            maxNum: 5,
            multipleTableColumn: {
                prop: 'name', 'value': '司机名称'
            },
            advanceConfig: [
                { prop: 'name', value: '司机名称' },
                { prop: 'encuMobile', value: '司机电话' }
            ],
            tableConfig: [
                { prop: 'name', value: '司机名称', displayName: true },
                { prop: 'encuMobile', value: '司机电话' }
            ],
            prefix: '/api-mdm',
            advanceUrl: 'suDriver/searchByConditions',
            cbParams: ['name#driver', 'encuMobile#driverContactWay']
        },
        {
            name: '承运商',
            advanceLabel: '承运商',
            value: 'carrierName',
            multiple: true,
            hideTooltip: true,
            maxNum: 5,
            multipleTableColumn: {
                prop: 'supplierNameCn', 'value': '承运商名称'
            },
            advanceConfig: [
                { prop: 'supplierNameCn', value: '承运商名称' },
                { prop: 'supplierCode', value: '承运商编码' }
            ],
            tableConfig: [
                { prop: 'supplierNameCn', value: '承运商名称', displayName: true },
                { prop: 'supplierCode', value: '承运商编码' },
                { prop: 'transNameListStr', value: '采购渠道' }
            ],
            requestMethod: 'post',
            prefix: '/api-tms',
            advanceUrl: '/srm/supplier/search',
            type: 'advanceMulti',
            advanceNotSearch: true,
            queryConditionRequired: true,
            cbParams: ['supplierNameCn#carrierName', 'supplierCode#carrierCode']
            // advanceCascade: 'supplierCode#carrierCode'
        },
        {
            name: '采购渠道',
            value: 'procurementChannelList',
            optionNum: 'OTP_TMS_PROCUREMENT_CHANNEL',
            filterable: true,
            multiple: true,
            options: [],
            type: 'select'
        },
        {
            name: '车牌号',
            advanceLabel: '车牌号',
            value: 'vehicleCard',
            multiple: true,
            border: true,
            hideTooltip: true,
            dialogWidth: '800px',
            maxNum: 5,
            multipleTableColumn: {
                prop: 'licensePlateNumber', 'value': '车牌'
            },
            advanceConfig: [
                { prop: 'licensePlateNumber', value: '车牌' },
                { prop: 'cargoVolumeStr', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            tableConfig: [
                { prop: 'licensePlateNumber', value: '车牌', displayName: true },
                { prop: 'cargoVolume', value: '载货体积' },
                { prop: 'cdegNameCn', value: '车型' }
            ],
            prefix: '/api-mdm',
            advanceUrl: 'suCar/searchByConditions',
            type: 'advanceMulti',
            cbParams: ['licensePlateNumber#vehicleCard'],
            // advanceCascade: 'carrierCode#suppliersCode',
            unfold: true,
            span: 5
        },
        {
            name: '专业公司',
            value: 'professionalCompanyList',
            type: 'select',
            multiple: true,
            options: [],
            optionNum: 'JD_PROFESSIONAL_COMPANY'
        },
        {
            name: '行业',
            value: 'industryCategoryList',
            type: 'select',
            multiple: true,
            options: [],
            optionNum: 'SYS_SUPPLIER_INDUSTRY'
        },
        {
            name: '是否及时处理',
            value: 'isTimelyDispose',
            type: 'select',
            multiple: false,
            optionNum: 'TIMELY_DISPOSE_TYPE',
            options: []
        },
        {
            name: '考核预警时间',
            value: 'assessWarningTime',
            type: 'time',
            startPlaceholder: '开始时间',
            endPlaceholder: '结束时间'
        }
    ],
    pickerConfig: {
        shortcuts: [{
                type: 'd',
                num: 6,
                text: '最近一周',
                translate: 'component.E202007300011'
            },
            {
                type: 'M',
                num: 1,
                text: '最近一个月',
                translate: 'component.E202007300013'
            },
            {
                type: 'M',
                num: 2,
                text: '最近两个月',
                translate: 'component.E1202104120940'
            },
            {
                type: 'M',
                text: '本月',
                toMonth: true,
                translate: 'component.E1202104120941'
            },
            {
                type: 'M',
                text: '上个月',
                lastMonth: true,
                translate: 'component.E1202104120942'
            }
        ]
    }
};
